import { FormProvider, useForm, UseFormProps, useWatch } from 'react-hook-form';
import FormEditOrAssignPermissionsHeader from './FormEditOrAssignPermissionsHeader';
import FormEditOrAssignPermissionsFooter from './FormEditOrAssignPermissionsFooter';
import FormEditOrAssignPermissionsBody from './FormEditOrAssignPermissionsBody';
import { FormLabelErrorMessage } from '@/components/forms';
import { DEFAULT_FORM_CONFIG } from '@/constants';
import { IHasEmployee } from '@/interfaces';
import { TFormData } from '.';

const VARIABLES = {
  formConfig: {
    ...DEFAULT_FORM_CONFIG,
    defaultValues: {
      roles: {
        permissions: [],
        employee: true,
        root: false
      },
      filter: {
        usernameOrEmail: ''
      }
    }
  } as UseFormProps<TFormData>
};

const FormEditOrAssignPermissions = ({ employee }: IHasEmployee) => {

  const formMethods = useForm<TFormData>({
    ...VARIABLES.formConfig,
    values: {
      ...VARIABLES.formConfig.defaultValues,
      ...employee
    } as TFormData
  });
  const errorMessage = useWatch({ control: formMethods.control, name: 'errorMessage' });

  return (
    <FormProvider {...formMethods}>
      <FormEditOrAssignPermissionsHeader />
      <FormEditOrAssignPermissionsBody />
      <FormLabelErrorMessage errorMessage={errorMessage} />
      <FormEditOrAssignPermissionsFooter />
    </FormProvider>
  );

};

export default FormEditOrAssignPermissions;
